/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './css/AboutHotelModal.css';
import { getPlainText } from '../../../Utils/CommonUtils';
import {
  COMMON_INFO,
  PLACEMENT,
  TERRITORY,
  IN_ROOM,
  ROOM_TYPES,
  SERVICES,
  SERVICES_FREE,
  SERVICES_PAY,
  ANIMATION,
  CHILD,
  BEACH,
  MEAL_LIST,
  MEAL_TYPES,
  HOTEL_DESC,
  BUILD,
  REPAIR,
} from '../../../Utils/Constants/GlobalConstants';
import { ReactComponent as Close } from '../../../images/close-r.svg';
import { ReactComponent as Check } from '../../../images/check.svg';
import { ReactComponent as Dot } from '../../../images/dot.svg';

function AboutHotelModal(props) {
  const {
    isVisible,
    modalNode,
    handleModalClick,
    hotelDetails,
    selectedCategory,
    setSelectedCategory,
  } = props;

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleEscPress = (e) => {
      if (e.key === 'Escape') {
        handleModalClick();
      }
    };

    document.addEventListener('keydown', handleEscPress, false);

    return () => {
      document.removeEventListener('keydown', handleEscPress, false);
    };
  }, [isVisible, handleModalClick]);

  const getCategoryTitle = () => {
    let result = '';

    switch (selectedCategory) {
      case 0:
        result = HOTEL_DESC;
        break;
      case 1:
        result = PLACEMENT;
        break;
      case 2:
        result = BEACH;
        break;
      case 3:
        result = TERRITORY;
        break;
      case 4:
        result = SERVICES;
        break;
      case 5:
        result = CHILD;
        break;
      case 6:
        result = MEAL_LIST;
        break;
      case 7:
        result = MEAL_TYPES;
        break;
      case 8:
        result = SERVICES_FREE;
        break;
      case 9:
        result = SERVICES_PAY;
        break;
      case 10:
        result = ANIMATION;
        break;
      case 11:
        result = IN_ROOM;
        break;
      case 12:
        result = ROOM_TYPES;
        break;
      default:
        result = '';
    }

    return result;
  };

  const getListItems = (text) =>
    getPlainText(text)
      .split(';')
      .map((item) => item.replace(/^[\s,]+|[\s,]+$/g, ''))
      .filter((item) => item.length > 0);

  const getDottedList = (text) => {
    const items = getListItems(text);
    const result = [];

    for (let i = 0; i < items.length; i++) {
      result.push(
        <div key={i} className="hd_about_check_item">
          <Dot className="hd_about_check_ico" />
          <span className="hd_about_text">{items[i]}</span>
        </div>,
      );
    }

    return result;
  };

  const getCheckedList = (text) => {
    const items = getListItems(text);
    const result = [];

    for (let i = 0; i < items.length; i++) {
      result.push(
        <div key={i} className="hd_about_check_item">
          <Check className="hd_about_check_ico" />
          <span className="hd_about_text">{items[i]}</span>
        </div>,
      );
    }

    return result;
  };

  const isHotelDescCommonVisible = (details) => details.build || details.repair;

  const getCategoryContent = () => {
    let result = '';

    switch (selectedCategory) {
      case 0:
        result = (
          <div>
            {hotelDetails.description && (
              <div className="hd_about_text hd_about_hotel_des">
                {getPlainText(hotelDetails.description)}
              </div>
            )}
            {isHotelDescCommonVisible(hotelDetails) && (
              <div className="hd_about_hotel_desc_common_w">
                <div className="bm_text_16">{COMMON_INFO}</div>
                <div>
                  {hotelDetails.build && (
                    <div className="br_text_16 mb_4">
                      <span>{BUILD}</span>
                      {`: ${hotelDetails.build}`}
                    </div>
                  )}
                  {hotelDetails.repair && (
                    <div className="br_text_16">
                      <span>{REPAIR}</span>
                      {`: ${hotelDetails.repair}`}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
        break;
      case 1:
        result = (
          <div className="hd_about_text">
            {getPlainText(hotelDetails.placement)}
          </div>
        );
        break;
      case 2:
        result = getDottedList(hotelDetails.beach);
        break;
      case 3:
        result = getCheckedList(hotelDetails.territory);
        break;
      case 4:
        result = getCheckedList(hotelDetails.services);
        break;
      case 5:
        result = getCheckedList(hotelDetails.child);
        break;
      case 6:
        result = getDottedList(hotelDetails.mealList);
        break;
      case 7:
        result = getDottedList(hotelDetails.mealTypes);
        break;
      case 8:
        result = getCheckedList(hotelDetails.serviceFree);
        break;
      case 9:
        result = getDottedList(hotelDetails.servicePay);
        break;
      case 10:
        result = getDottedList(hotelDetails.animation);
        break;
      case 11:
        result = getCheckedList(hotelDetails.inRoom);
        break;
      case 12:
        result = getDottedList(hotelDetails.roomTypes);
        break;
      default:
        result = '';
    }

    return result;
  };

  const getAboutContent = () => (
    <div className="hd_about_content">
      <div className="hd_about_modal_title_line">
        <div className="hd_about_modal_title">{getCategoryTitle()}</div>
        <button
          type="button"
          className="hd_about_close_but"
          onClick={handleModalClick}
        >
          <Close />
        </button>
      </div>
      <div className="br_text_16 hd_about_hotel_about_w blue_scroll_container">
        {getCategoryContent()}
      </div>
    </div>
  );

  return (
    <div
      className={`hd_about_modal_container ${
        isVisible ? 'hd_about_modal_open' : ''
      }`}
    >
      <div
        className="hd_about_modal"
        ref={(node) => {
          modalNode.current = node;
        }}
      >
        <div className="hd_about_container">
          <div className="hd_about_hotel_left custom_scroll_container">
            <button
              type="button"
              className={
                selectedCategory === 0
                  ? 'hd_about_cat_but hd_about_cat_but_slected'
                  : 'hd_about_cat_but'
              }
              onClick={() => setSelectedCategory(0)}
            >
              <div className="bm_text_16">{COMMON_INFO}</div>
            </button>

            {hotelDetails.placement && (
              <button
                type="button"
                className={
                  selectedCategory === 1
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(1)}
              >
                <div className="bm_text_16">{PLACEMENT}</div>
              </button>
            )}

            {hotelDetails.beach && (
              <button
                type="button"
                className={
                  selectedCategory === 2
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(2)}
              >
                <div className="bm_text_16">{BEACH}</div>
              </button>
            )}

            {hotelDetails.territory && (
              <button
                type="button"
                className={
                  selectedCategory === 3
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(3)}
              >
                <div className="bm_text_16">{TERRITORY}</div>
              </button>
            )}

            {hotelDetails.services && (
              <button
                type="button"
                className={
                  selectedCategory === 4
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(4)}
              >
                <div className="bm_text_16">{SERVICES}</div>
              </button>
            )}

            {hotelDetails.child && (
              <button
                type="button"
                className={
                  selectedCategory === 5
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(5)}
              >
                <div className="bm_text_16">{CHILD}</div>
              </button>
            )}

            {hotelDetails.mealList && (
              <button
                type="button"
                className={
                  selectedCategory === 6
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(6)}
              >
                <div className="bm_text_16">{MEAL_LIST}</div>
              </button>
            )}

            {hotelDetails.mealTypes && (
              <button
                type="button"
                className={
                  selectedCategory === 7
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(7)}
              >
                <div className="bm_text_16">{MEAL_TYPES}</div>
              </button>
            )}

            {hotelDetails.serviceFree && (
              <button
                type="button"
                className={
                  selectedCategory === 8
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(8)}
              >
                <div className="bm_text_16">{SERVICES_FREE}</div>
              </button>
            )}

            {hotelDetails.servicePay && (
              <button
                type="button"
                className={
                  selectedCategory === 9
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(9)}
              >
                <div className="bm_text_16">{SERVICES_PAY}</div>
              </button>
            )}

            {hotelDetails.animation && (
              <button
                type="button"
                className={
                  selectedCategory === 10
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(10)}
              >
                <div className="bm_text_16">{ANIMATION}</div>
              </button>
            )}

            {hotelDetails.inRoom && (
              <button
                type="button"
                className={
                  selectedCategory === 11
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(11)}
              >
                <div className="bm_text_16">{IN_ROOM}</div>
              </button>
            )}

            {hotelDetails.roomTypes && (
              <button
                type="button"
                className={
                  selectedCategory === 12
                    ? 'hd_about_cat_but hd_about_cat_but_slected'
                    : 'hd_about_cat_but'
                }
                onClick={() => setSelectedCategory(12)}
              >
                <div className="bm_text_16">{ROOM_TYPES}</div>
              </button>
            )}
          </div>
          <div className="hd_about_hotel_right">{getAboutContent()}</div>
        </div>
      </div>
    </div>
  );
}

AboutHotelModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  modalNode: PropTypes.instanceOf(Object).isRequired,
  handleModalClick: PropTypes.func.isRequired,
  hotelDetails: PropTypes.instanceOf(Object).isRequired,
  selectedCategory: PropTypes.number.isRequired,
  setSelectedCategory: PropTypes.func.isRequired,
};

export default AboutHotelModal;
